"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
var useStyles = makeStyles_1["default"](function (theme) { return ({
    cancel: {
        marginLeft: theme.spacing(3)
    }
}); });
var CancelButton = function (props) {
    var classes = useStyles();
    var onClick = props.onClick, _a = props.label, label = _a === void 0 ? 'Cancel' : _a;
    return (react_1["default"].createElement(Button_1["default"], { variant: "contained", size: "large", className: classes.cancel, onClick: onClick }, label));
};
exports["default"] = CancelButton;
